var map = {
	"./logo-1-01.svg": 2736,
	"./logo-1-02.svg": 6028,
	"./logo-2-01.svg": 3082,
	"./logo-2-02.svg": 6796,
	"./logo-2-04.svg": 2727,
	"./logo-2-05.svg": 9713,
	"./logo-2-06.jpeg": 7380,
	"./logo-2-07.png": 8486,
	"./logo-3-00.svg": 6426,
	"./logo-3-01.svg": 2718,
	"./logo-3-02.svg": 3826,
	"./logo-3-03.svg": 1782,
	"./logo-3-04.svg": 9705,
	"./logo-3-05.svg": 9738,
	"./logo-3-06.svg": 7803,
	"./logo-3-07_.svg": 7962,
	"./logo-3-08_.svg": 8072,
	"./logo-3-08__.jpg": 4238,
	"./logo-3-09.svg": 418,
	"./logo-3-09_.png": 812,
	"./logo-3-10.svg": 1513,
	"./logo-3-11.svg": 6337,
	"./logo-3-13.svg": 3033,
	"./logo-3-14.jpg": 3141,
	"./logo-3-15.png": 8214,
	"./logo-3-16.jpg": 9630,
	"./logo-3-17.png": 7643,
	"./logo-3-18.png": 2693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8190;